// Textos del widget: id de la tabla `traducciones` y texto por defecto.
//
// GENERADO por scripts/f1-widget/generar-markup.js desde
// clases/Modulos/Core/Elementos/BuscadorDestinos/portadaRenfeViajes#buscadorDestinos.tpl
// (y los dos modales de pasajeros del tren + coche, desde buscadorTrenCoches#buscadorDestinos.tpl)
// No editar a mano mientras la home siga usando la plantilla Smarty: en F7 el buscador de la
// home pasa a ser este widget, y entonces este fichero se convierte en la única fuente.

// En F5 el build vuelca aquí la traducción real de es/en/fr. Hasta entonces vale el texto
// por defecto de la plantilla, que es el castellano.
//
// OJO: {tr} en el proyecto NO cae al texto por defecto si el id no existe en la tabla: lanza
// una excepción y tumba la página. El widget hace justo lo contrario, porque un texto que
// falte no puede tirar la landing de un tercero.

export const textosPorDefecto = {
  188: "Niños",
  416: "Desde",
  7236: "Estación Origen",
  7237: "Estación Destino",
  7238: "Seleccione una estación válida",
  7239: "Niños",
  7240: "Niños",
  7241: "Sin ocupar plaza",
  7242: "Listo",
  7243: "Borrar fechas",
  7244: "Buscar billete",
  7245: "Pasajero",
  7246: "Pasajeros",
  7247: "Busca tu producto o ciudad aquí",
  7248: "Actividad",
  7249: "Buscar hotel",
  7259: "Seleccione una opción válida",
  7331: "Tren + Hotel / Ocio",
  7336: "¿Quieres añadir hotel al viaje?",
  7337: "No",
  7338: "Selecciona pasajeros",
  7339: "Más de 13 años",
  7340: "De 0 a 13 años",
  7341: "De 0 a 3 años. No ocupan plaza",
  7386: "Tren + Coche de alquiler",
  7388: "Edad conductor",
  20012: "Aviso",
  20013: "En paquetes con hotel, no es posible seleccionar el mismo dia de ida y vuelta",
  20766: "Si",
  20808: "Hasta",
  20814: "Productos",
  20815: "Destinos",
  24531: "Adultos",
  24543: "Edades",
  24560: "Ocio",
  24642: "Habitaciones",
  24643: "Habitación",
  24851: "Seleccionar",
  25940: "Habitacion",
  25942: "Adultos",
  25953: "Habitaciones",
  25967: "Fecha de salida del Hotel",
  41044: "Ciudad",
  45897: "Sólo ida",
  45898: "Ida y vuelta",
  46510: "Cancelar",
  46615: "Sin regreso",
  46629: "escoger horarios",
  46630: "Aceptar",
  46641: "Seleccione",
  87088: "Viaje ida y vuelta",
  147090: "Hotel",
  344623: "Viaje sólo ida",
  1479751: "Tren + Hotel + Ocio",
  1479756: "Fecha Salida Tren",
  1479757: "Fecha Regreso Hotel",
  2011810: "¿Desde cuándo hasta cuándo quieres el coche?",
}

// Los <span id="texto_*"> ocultos que el buscador actual deja en el DOM para que el JS
// pluralice leyendo del documento. Aquí son datos, no nodos: el valor es el id de
// traducción, que el runtime resuelve igual que el resto de textos.
export const plurales = {
  "texto_habitacion": 25940,
  "texto_habitaciones": 24642,
  "texto_adultos": 25942,
  "texto_childs": 188,
  "texto_pasajero": 7245,
  "texto_pasajeros": 7246,
  "texto-aviso-titulo-swal": 20012,
  "texto-aviso-texto-swal": 20013,
  "texto-aviso-confirmar-swal": 46630,
}
